import { Title } from '../title/index';
import { Paragraph } from '../paragraph/index';
import { OSS_CDN } from '@/utils/pathConfig';
import styles from './../../index.module.scss';
export const Abstract = () => {
  return (
    <div>
      <div className={styles.privacyName}>
        《海底捞外送小程序隐私条款摘要》摘要
      </div>
      <Paragraph>
        我们非常重视保护您的隐私和个人信息。我们将通过本摘要向您简单、直观的说明《海底捞隐私政策》的核心内容。更多有关我们对您的人心信息的处理规则，请您查阅《海底捞隐私政策》。
      </Paragraph>
      <Title bold>个人信息收集和处理</Title>
      <Paragraph>
        以下为您使用我们产品和服务的功能我们可能收集和使用的您的个人信息。
      </Paragraph>
      <Paragraph bold>1.注册/登录</Paragraph>
      <Paragraph>手机号码</Paragraph>
      <Paragraph bold>2.线上点餐</Paragraph>
      <Paragraph>姓名、电话号码、定位信息、地址</Paragraph>
      <Paragraph bold>3.外送服务</Paragraph>
      <Paragraph>姓名、电话号码、地址</Paragraph>
      <Paragraph bold>4.在线客服咨询及投诉回访</Paragraph>
      <Paragraph>相机权限</Paragraph>
      <Paragraph>权限列表</Paragraph>
      <img className={styles.image} alt="权限列表" src={`${OSS_CDN}qxlb.png`} />
      <Title bold>如何共享您的个人信息？</Title>
      <Paragraph>
        涉及共享时，我们遵循“合法正当、最小必要原则”，进行个人信息保护影响评估，并采取技术保护措施，签署数据安全的保护协议，严格要求合作商的业务与责任。关于我们与第三方共享的个人信息的详细情况，请见《个人信息第三方共享清单》
      </Paragraph>
      <Paragraph>小程序与第三方共享信息清单</Paragraph>
      <img
        className={styles.image}
        alt="小程序与第三方共享信息清单"
        src={`${OSS_CDN}xxgx.png`}
      />
      <Paragraph>第三方SDK的使用</Paragraph>
      <img
        className={styles.image}
        alt="第三方SDK的使用"
        src={`${OSS_CDN}sdk.png`}
      />
      <img
        className={styles.image}
        alt="海底捞外送（快手）小程序内嵌第三方SDK详情"
        src={`${OSS_CDN}ks2.png`}
      />
      <Title bold>个人信息权利行使</Title>
      <Paragraph>查询权与更正权</Paragraph>
      <Paragraph>您可以按照下述指引路径查询或更正您的个人信息：</Paragraph>
      <Paragraph>
        您可以在海底捞外送小程序的“订单”入口，查询最近一年的订单。您可以通过海底捞外送小程序“我的”入口，进入个人信息页面，以访问您的昵称、性别、联系电话和出生日期。您可以在海底捞外送小程序的“地址管理”页面查询或更正您的个人信息，包括收件人姓名、联系电话、收件地址。
      </Paragraph>
      <Paragraph bold>
        或者您可通过下方【联系我们】所述方式，提出查询、更正我们保有的有关您的个人信息的要求，法律法规规定的例外情况除外。
      </Paragraph>
      <Paragraph bold>账号注销</Paragraph>
      <Paragraph>
        您有权申请注销您的海底捞会员账户，您可以通过拨打“4009107107”的方式注销账号，我们将在15个工作日内答复您的请求。
      </Paragraph>
      <Paragraph bold>复制权</Paragraph>
      <Paragraph>
        您有权通过海底捞APP【我的】-【设置】-【隐私设置】-【个人信息浏览与导出】页面下载个人信息。
      </Paragraph>
      <Paragraph bold>删除权</Paragraph>
      <Paragraph>
        您有权通过向隐私负责人邮箱：【dataprivacy@haidilao.com】；向【北京市昌平区东小口镇中东路398号1号楼7层】邮编：102218发送邮件；或您可拨打海底捞客服电话：4009107107。
        <b>联系我们要求我们删除个人信息。</b>
      </Paragraph>
      <Paragraph bold>7.4改变/撤回授权同意</Paragraph>
      <Paragraph>
        您有权在对
        <b>
          所使用设备的相关权限、推送开关授权后随时撤回（或停止）对对应权限/功能的继续授权；或者您可以拨打电话：4009107107或向【kfzx@haidilao.com】
          发送邮件的形式，向我们提出改变或撤回您授权我们收集和处理您的个人信息的范围，撤回对隐私政策的同意。
        </b>
      </Paragraph>
      <Title bold>如何联系我们？</Title>
      <Paragraph>您可以通过选择以下任意一种方式联系我们：</Paragraph>
      <Paragraph>隐私负责人邮箱：【dataprivacy@haidilao.com】</Paragraph>
      <Paragraph>
        联系地址为：【北京市昌平区东小口镇中东路398号1号楼7层】
      </Paragraph>
      <Paragraph>邮编：102218 </Paragraph>
      <Paragraph>您可拨打海底捞客服电话：4009107107。</Paragraph>
    </div>
  );
};
